import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-edit-resource-anagraf',
  templateUrl: './edit-resource-anagraf.component.html',
  styleUrls: ['./edit-resource-anagraf.component.scss']
})
export class EditResourceAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  resourceUnit: ResourcesUnitModel;
  registerForm: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;

  idResource: number;
  nameResource: string;
  codResource: string;
  offsetResource: number;
  submitted = false;
  resourceUnitJson: any;


  constructor(private route: ActivatedRoute, private router: Router,
              private resourceUnitService: ResourceUnitService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.resourceUnitJson = params['row'];
      });

    this.resourceUnit = new ResourcesUnitModel();
    this.formBuilder = new FormBuilder();


    this.registerForm = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      name: [{value: '', disabled: false}, Validators.required],
      offset: [{value: '', disabled: false}]
    });

    this.resourceUnit = JSON.parse(this.resourceUnitJson) as ResourcesUnitModel;

    this.registerForm.patchValue({
      cod: this.resourceUnit ? this.resourceUnit.cod : ''
    });

    this.registerForm.patchValue({
      name: this.resourceUnit ? this.resourceUnit.name : ''
    });

    this.registerForm.patchValue({
      offset: this.resourceUnit ? this.resourceUnit.offset : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.idResource = params['id'];
      this.codResource = params['cod'];
      this.nameResource = params['name'];
      this.offsetResource = params['offset'];
    });

  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.resourceUnit.cod = this.registerForm.controls['cod'].value;
      this.resourceUnit.name = this.registerForm.controls['name'].value;
      this.resourceUnit.offset = this.registerForm.controls['offset'].value;
      this.saveSubscribe = this.resourceUnitService.update(this.resourceUnitService.baseUrl, this.resourceUnit).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Resource Unit Cod already exists', 'Warning');
          }
           else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Resource unit was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF]);
          }
          
        }, error => {
          toastr.error('Resource unit was not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  get f() { return this.registerForm.controls; }

}
